import { Record } from 'immutable';

export default class CustomerRecord extends Record({
  id: null,
  address: undefined,
  agreements: undefined,
  bjornLundenSettings: undefined,
  children: undefined,
  contacts: undefined,
  customerNumber: undefined,
  externalReference: undefined,
  fax: undefined,
  files: undefined,
  fortnoxSettings: undefined,
  globalLocationNumber: undefined,
  hierarchy: undefined,
  information: undefined,
  invoiceAddress: undefined,
  invoiceBccEmail: undefined,
  invoiceCcEmail: undefined,
  invoiceDeliveryType: undefined,
  invoiceEmail: undefined,
  invoiceText: undefined,
  lastInteractionEvent: undefined,
  links: undefined,
  name: null,
  notes: undefined,
  organisationNumber: undefined,
  owningUser: undefined,
  parent: undefined,
  phone: undefined,
  status: undefined,
  type: 'Customer',
  url: undefined,
  visible: undefined,
}) {
}
